<template>
  <v-overlay :model-value="true"
             :persistent="true"
             :z-index="999"
  >
    <div class="d-flex flex-column">
      <div class="Unauthorized-title mb-6">
        {{ $t('common.UnauthorizedOverlay.unauthorized') }}
      </div>
      <AppButton color="primary"
                 class="align-self-center"
                 @click="logout"
      >
        {{ $t('common.UnauthorizedOverlay.logout') }}
      </AppButton>
    </div>
  </v-overlay>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'
import { LOGOUT_ROUTE_NAME } from '@/router'

export default {
  name: 'UnauthorizedOverlay',
  components: {
    AppButton,
  },
  methods: {
    logout () {
      this.$router.replace({ name: LOGOUT_ROUTE_NAME })
    },
  },
}
</script>

<style scoped lang="scss">
.Unauthorized-title {
  text-align: center;
  font-size: 30px;
}

:deep(.v-overlay__scrim) {
  opacity: 1;
}
</style>
